import { render, staticRenderFns } from "./deleteProductGroup.vue?vue&type=template&id=4170a500"
import script from "./deleteProductGroup.vue?vue&type=script&lang=js"
export * from "./deleteProductGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports